import { isTextNode } from '@creative/nodes';
import {
    IElementDataNode,
    IState,
    OneOfElementPropertyKeys,
    OneOfStatesDto,
    statePropertyToUnitMap,
    textStatePropertyToUnitMap
} from '@studio/domain';
import { isNumber } from '@studio/utils/utils';
import { isStateProperty } from '../rendering';
import { roundPosition } from './data-element-serializer';
import { deserializeProperty, convertPropertyToDto } from './property-serializer';

export function convertStateToDto(state: IState, node: IElementDataNode): OneOfStatesDto {
    const stateDto = { id: state.id! };
    for (const property in state) {
        const value = state[property];
        const stateProperties = isTextNode(node) ? textStatePropertyToUnitMap : statePropertyToUnitMap;

        const isStatePropertyWithValue = property in stateProperties && value !== undefined;

        if (isStatePropertyWithValue) {
            stateDto[property] = convertPropertyToDto(property as OneOfElementPropertyKeys, value);
            if ((property === 'x' || property === 'y') && isNumber(stateDto[property])) {
                stateDto[property] = roundPosition(stateDto[property]);
            }
        }
    }
    return stateDto;
}

export function deserializeState(stateDto: OneOfStatesDto): IState {
    const state = { id: stateDto.id };
    for (const property in stateDto) {
        if (property !== 'id' && isStateProperty(property) && stateDto[property] !== undefined) {
            state[property] = deserializeProperty(property, stateDto[property]);
        }
    }
    return state;
}
